import blog_image from "../assets/ilustrations/blog_image.svg";
import profilePicture_image from "../assets/ilustrations/profilePicture_image.svg";

export const blogSections = [
  {
    className: "blogCard",
    imgClass: "blogImg",
    src: blog_image,
    title: "Creative project management and practices for 2021",
    href: "#",

    linkText: "Read more >>",
  },
  {
    className: "blogCard",
    imgClass: "blogImg",
    src: blog_image,
    title: "Creative project management and practices for 2021",
    href: "#",

    linkText: "Read more >>",
  },
  {
    className: "blogCard",
    imgClass: "blogImg",
    src: blog_image,
    title: "Creative project management and practices for 2021",
    href: "#",

    linkText: "Read more >>",
  },
  {
    className: "blogCard",
    imgClass: "blogImg",
    src: blog_image,
    title: "Creative project management and practices for 2021",
    href: "#",

    linkText: "Read more >>",
  },
];

export const TableDatas = [
  {
    id: 1,
    certificate: "IPMA-D-2015-8019",
    surname: "Ristic",
    firstName: "Bojan",
    location: "Serbia",
    salutation: "IPMA-D-2015-9012",
    postcode: "18000",
    certificationDate: new Date(2015, 9, 3),
    certificationStatus: true,
    detail: "",
  },
  {
    id: 2,
    certificate: "IPMA-D-2015-8019",
    surname: "A.Marca",
    firstName: "Fabian",
    location: "Regensdorf",
    salutation: "IPMA-D-2015-8019",
    postcode: "102262",
    certificationDate: new Date(2015, 9, 3),
    certificationStatus: true,
    detail: "",
  },
  {
    id: 3,
    certificate: "IPMA-D-2015-8019",
    surname: "A.Marca",
    firstName: "Fabian",
    location: "Regensdorf",
    salutation: "IPMA-D-2015-8019",
    postcode: "102262",
    certificationDate: new Date(2015, 9, 3),
    certificationStatus: true,
    detail: "",
  },
  {
    id: 4,
    certificate: "IPMA-D-2015-8019",
    surname: "A.Marca",
    firstName: "Fabian",
    location: "Regensdorf",
    salutation: "IPMA-D-2015-8019",
    postcode: "102262",
    certificationDate: new Date(2015, 9, 3),
    certificationStatus: true,
    detail: "",
  },
  {
    id: 5,
    certificate: "IPMA-D-2015-8019",
    surname: "A.Marca",
    firstName: "Fabian",
    location: "Regensdorf",
    salutation: "IPMA-D-2015-8019",
    postcode: "102262",
    certificationDate: new Date(2015, 9, 3),
    certificationStatus: true,
    detail: "",
  },
  {
    id: 6,
    certificate: "IPMA-D-2015-8019",
    surname: "A.Marca",
    firstName: "Fabian",
    location: "Regensdorf",
    salutation: "IPMA-D-2015-8019",
    postcode: "102262",
    certificationDate: new Date(2015, 9, 3),
    certificationStatus: true,
    detail: "",
  },
  {
    id: 7,
    certificate: "IPMA-D-2015-8019",
    surname: "A.Marca",
    firstName: "Fabian",
    location: "Regensdorf",
    salutation: "IPMA-D-2015-8019",
    postcode: "102262",
    certificationDate: new Date(2015, 9, 3),
    certificationStatus: true,
    detail: "",
  },
  {
    id: 8,
    certificate: "IPMA-D-2015-8019",
    surname: "A.Marca",
    firstName: "Fabian",
    location: "Regensdorf",
    salutation: "IPMA-D-2015-8019",
    postcode: "102262",
    certificationDate: new Date(2015, 9, 3),
    certificationStatus: true,
    detail: "",
  },
  {
    id: 9,
    certificate: "IPMA-D-2015-8019",
    surname: "A.Marca",
    firstName: "Fabian",
    location: "Regensdorf",
    salutation: "IPMA-D-2015-8019",
    postcode: "102262",
    certificationDate: new Date(2015, 9, 3),
    certificationStatus: true,
    detail: "",
  },
  {
    id: 10,
    certificate: "IPMA-D-2015-8019",
    surname: "A.Marca",
    firstName: "Fabian",
    location: "Regensdorf",
    salutation: "IPMA-D-2015-8019",
    postcode: "102262",
    certificationDate: new Date(2015, 9, 3),
    certificationStatus: true,
    detail: "",
  },
  {
    id: 11,
    certificate: "IPMA-D-2015-8019",
    surname: "A.Marca",
    firstName: "Fabian",
    location: "Regensdorf",
    salutation: "IPMA-D-2015-8019",
    postcode: "102262",
    certificationDate: new Date(2015, 9, 3),
    certificationStatus: true,
    detail: "",
  },
  {
    id: 12,
    certificate: "IPMA-D-2015-8019",
    surname: "A.Marca",
    firstName: "Fabian",
    location: "Regensdorf",
    salutation: "IPMA-D-2015-8019",
    postcode: "102262",
    certificationDate: new Date(2015, 9, 3),
    certificationStatus: true,
    detail: "",
  },
  {
    id: 13,
    certificate: "IPMA-D-2015-8019",
    surname: "A.Marca",
    firstName: "Fabian",
    location: "Regensdorf",
    salutation: "IPMA-D-2015-8019",
    postcode: "102262",
    certificationDate: new Date(2015, 9, 3),
    certificationStatus: true,
    detail: "",
  },
  {
    id: 14,
    certificate: "IPMA-D-2015-8019",
    surname: "A.Marca",
    firstName: "Fabian",
    location: "Regensdorf",
    salutation: "IPMA-D-2015-8019",
    postcode: "102262",
    certificationDate: new Date(2015, 9, 3),
    certificationStatus: true,
    detail: "",
  },
  {
    id: 15,
    certificate: "IPMA-D-2015-8019",
    surname: "A.Marca",
    firstName: "Fabian",
    location: "Regensdorf",
    salutation: "IPMA-D-2015-8019",
    postcode: "102262",
    certificationDate: new Date(2015, 9, 3),
    certificationStatus: true,
    detail: "",
  },
  {
    id: 16,
    certificate: "IPMA-D-2015-8019",
    surname: "A.Marca",
    firstName: "Fabian",
    location: "Regensdorf",
    salutation: "IPMA-D-2015-8019",
    postcode: "102262",
    certificationDate: new Date(2015, 9, 3),
    certificationStatus: true,
    detail: "",
  },
  {
    id: 17,
    certificate: "IPMA-D-2015-8019",
    surname: "A.Marca",
    firstName: "Fabian",
    location: "Regensdorf",
    salutation: "IPMA-D-2015-8019",
    postcode: "102262",
    certificationDate: new Date(2015, 9, 3),
    certificationStatus: true,
    detail: "",
  },
  {
    id: 18,
    certificate: "IPMA-D-2015-8019",
    surname: "A.Marca",
    firstName: "Fabian",
    location: "Regensdorf",
    salutation: "IPMA-D-2015-8019",
    postcode: "102262",
    certificationDate: new Date(2015, 9, 3),
    certificationStatus: true,
    detail: "",
  },
  {
    id: 19,
    certificate: "IPMA-D-2015-8019",
    surname: "A.Marca",
    firstName: "Fabian",
    location: "Regensdorf",
    salutation: "IPMA-D-2015-8019",
    postcode: "102262",
    certificationDate: new Date(2015, 9, 3),
    certificationStatus: true,
    detail: "",
  },
  {
    id: 20,
    certificate: "IPMA-D-2015-8019",
    surname: "A.Marca",
    firstName: "Fabian",
    location: "Regensdorf",
    salutation: "IPMA-D-2015-8019",
    postcode: "102262",
    certificationDate: new Date(2015, 9, 3),
    certificationStatus: true,
    detail: "",
  },
  {
    id: 21,
    certificate: "IPMA-D-2015-8019",
    surname: "A.Marca",
    firstName: "Fabian",
    location: "Regensdorf",
    salutation: "IPMA-D-2015-8019",
    postcode: "102262",
    certificationDate: new Date(2015, 9, 3),
    certificationStatus: true,
    detail: "",
  },
  {
    id: 22,
    certificate: "IPMA-D-2015-8019",
    surname: "A.Marca",
    firstName: "Fabian",
    location: "Regensdorf",
    salutation: "IPMA-D-2015-8019",
    postcode: "102262",
    certificationDate: new Date(2015, 9, 3),
    certificationStatus: true,
    detail: "",
  },
  {
    id: 23,
    certificate: "IPMA-D-2015-8019",
    surname: "A.Marca",
    firstName: "Fabian",
    location: "Regensdorf",
    salutation: "IPMA-D-2015-8019",
    postcode: "102262",
    certificationDate: new Date(2015, 9, 3),
    certificationStatus: true,
    detail: "",
  },
];
export const AssessorsData = [
  {
    id: 1,
    certificate: "A.Marca",
    surname: "Fabian",
    firstName: "Regensdorf",
    location: "20 January 2018",
    assessorsLevel: "Level A,B & C",
  },
  {
    id: 2,
    certificate: "A.Marca",
    surname: "Fabian",
    firstName: "Regensdorf",
    location: "20 January 2018",
    assessorsLevel: "Level A,B & C",
  },
  {
    id: 3,
    certificate: "A.Marca",
    surname: "Fabian",
    firstName: "Regensdorf",
    location: "20 January 2018",
    assessorsLevel: "Level A,B & C",
  },
  {
    id: 4,
    certificate: "A.Marca",
    surname: "Fabian",
    firstName: "Regensdorf",
    location: "20 January 2018",
    assessorsLevel: "Level A,B & C",
  },
  {
    id: 5,
    certificate: "A.Marca",
    surname: "Fabian",
    firstName: "Regensdorf",
    location: "20 January 2018",
    assessorsLevel: "Level A,B & C",
  },
  {
    id: 6,
    certificate: "A.Marca",
    surname: "Fabian",
    firstName: "Regensdorf",
    location: "20 January 2018",
    assessorsLevel: "Level A,B & C",
  },
  {
    id: 7,
    certificate: "A.Marca",
    surname: "Fabian",
    firstName: "Regensdorf",
    location: "20 January 2018",
    assessorsLevel: "Level A,B & C",
  },
  {
    id: 8,
    certificate: "A.Marca",
    surname: "Fabian",
    firstName: "Regensdorf",
    location: "20 January 2018",
    assessorsLevel: "Level A,B & C",
  },
  {
    id: 9,
    certificate: "A.Marca",
    surname: "Fabian",
    firstName: "Regensdorf",
    location: "20 January 2018",
    assessorsLevel: "Level A,B & C",
  },
  {
    id: 10,
    certificate: "A.Marca",
    surname: "Fabian",
    firstName: "Regensdorf",
    location: "20 January 2018",
    assessorsLevel: "Level A,B & C",
  },
  {
    id: 11,
    certificate: "A.Marca",
    surname: "Fabian",
    firstName: "Regensdorf",
    location: "20 January 2018",
    assessorsLevel: "Level A,B & C",
  },
  {
    id: 12,
    certificate: "A.Marca",
    surname: "Fabian",
    firstName: "Regensdorf",
    location: "20 January 2018",
    assessorsLevel: "Level A,B & C",
  },
  {
    id: 13,
    certificate: "A.Marca",
    surname: "Fabian",
    firstName: "Regensdorf",
    location: "20 January 2018",
    assessorsLevel: "Level A,B & C",
  },
  {
    id: 14,
    certificate: "A.Marca",
    surname: "Fabian",
    firstName: "Regensdorf",
    location: "20 January 2018",
    assessorsLevel: "Level A,B & C",
  },
  {
    id: 15,
    certificate: "A.Marca",
    surname: "Fabian",
    firstName: "Regensdorf",
    location: "20 January 2018",
    assessorsLevel: "Level A,B & C",
  },
  {
    id: 16,
    certificate: "A.Marca",
    surname: "Fabian",
    firstName: "Regensdorf",
    location: "20 January 2018",
    assessorsLevel: "Level A,B & C",
  },
  {
    id: 17,
    certificate: "A.Marca",
    surname: "Fabian",
    firstName: "Regensdorf",
    location: "20 January 2018",
    assessorsLevel: "Level A,B & C",
  },
  {
    id: 19,
    certificate: "A.Marca",
    surname: "Fabian",
    firstName: "Regensdorf",
    location: "20 January 2018",
    assessorsLevel: "Level A,B & C",
  },
  {
    id: 20,
    certificate: "A.Marca",
    surname: "Fabian",
    firstName: "Regensdorf",
    location: "20 January 2018",
    assessorsLevel: "Level A,B & C",
  },
  {
    id: 21,
    certificate: "A.Marca",
    surname: "Fabian",
    firstName: "Regensdorf",
    location: "20 January 2018",
    assessorsLevel: "Level A,B & C",
  },
  {
    id: 22,
    certificate: "A.Marca",
    surname: "Fabian",
    firstName: "Regensdorf",
    location: "20 January 2018",
    assessorsLevel: "Level A,B & C",
  },
  {
    id: 23,
    certificate: "A.Marca",
    surname: "Fabian",
    firstName: "Regensdorf",
    location: "20 January 2018",
    assessorsLevel: "Level A,B & C",
  },
  {
    id: 24,
    certificate: "A.Marca",
    surname: "Fabian",
    firstName: "Regensdorf",
    location: "20 January 2018",
    assessorsLevel: "Level A,B & C",
  },
  {
    id: 25,
    certificate: "A.Marca",
    surname: "Fabian",
    firstName: "Regensdorf",
    location: "20 January 2018",
    assessorsLevel: "Level A,B & C",
  },
];
export const SchemeCommittee = [
  {
    imgSrc: profilePicture_image,
    fullName: "Ed Naughton",
    jobTitle: "Chairperson",
  },
  {
    imgSrc: profilePicture_image,
    fullName: "John Atkinson",
    jobTitle: "International assessor, COD",
  },
  {
    imgSrc: profilePicture_image,
    fullName: "Liam Halloran",
    jobTitle: " Assessor",
  },
];

export const ComplaintsAppealsCommittee = [
  {
    imgSrc: profilePicture_image,
    fullName: "John Atkinson",
    jobTitle: " Assessor",
  },
  {
    imgSrc: profilePicture_image,
    fullName: "Fiona Cranley",
    jobTitle: " Assessor",
  },
  {
    imgSrc: profilePicture_image,
    fullName: "Other Assessors",
    jobTitle: "----",
  },
];
export const Assessors = [
  {
    imgSrc: profilePicture_image,
    fullName: "John Atkinson",
    jobTitle: "(Lead & COD)",
  },
  {
    imgSrc: profilePicture_image,
    fullName: "Fred Barry",
    jobTitle: " Assessor",
  },
  {
    imgSrc: profilePicture_image,
    fullName: "Liam Halloran",
    jobTitle: "Chairperson",
  },
  {
    imgSrc: profilePicture_image,
    fullName: "Derek Tierney",
    jobTitle: "Chairperson",
  },
  {
    imgSrc: profilePicture_image,
    fullName: "Seamus Woods",
    jobTitle: "Chairperson",
  },
  {
    imgSrc: profilePicture_image,
    fullName: "Jackie Glynn",
    jobTitle: "Chairperson",
  },
  {
    imgSrc: profilePicture_image,
    fullName: "David Shiel",
    jobTitle: "Chairperson",
  },
  {
    imgSrc: profilePicture_image,
    fullName: "Fiona Cranley",
    jobTitle: "Chairperson",
  },
];

export const NewCoAssessors = [
  {
    imgSrc: profilePicture_image,
    fullName: "Ailish Farrelly",
    jobTitle: "Level C co-assessor",
  },
  {
    imgSrc: profilePicture_image,
    fullName: "Stephen Sheridan",
    jobTitle: "Level C co-assessor",
  },
  {
    imgSrc: profilePicture_image,
    fullName: "Krystyna Dimtchev",
    jobTitle: "Level C co-assessor",
  },
];
export const Adminstrations = [
  {
    imgSrc: profilePicture_image,
    fullName: "Daniela Stroiescu",
    jobTitle: "Finance & Logistics personnel",
  },
  {
    imgSrc: profilePicture_image,
    fullName: "Patricia Calao",
    jobTitle: "Administration, Web & Services Planning",
  },
  {
    imgSrc: profilePicture_image,
    fullName: "John Naughton",
    jobTitle: "Administration, Web & Services Planning",
  },
  {
    imgSrc: profilePicture_image,
    fullName: "Daniela Stroiescu",
    jobTitle: "Certification Manager",
  },
];
export const latestNews = [
  {
    src: blog_image,
    title: "Creative project management and practices for 2021",
    subtitle:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Eu nisi amet in pellentesque. Imperdiet ac amet arcu lectus in sodales tristique varius libero....",
    href: "#",
    linkText: "Read more >>",
  },
  {
    src: blog_image,
    title: "Creative project management and practices for 2021",
    subtitle:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Eu nisi amet in pellentesque. Imperdiet ac amet arcu lectus in sodales tristique varius libero....",
    href: "#",
    linkText: "Read more >>",
  },
  {
    src: blog_image,
    title: "Creative project management and practices for 2021",
    subtitle:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Eu nisi amet in pellentesque. Imperdiet ac amet arcu lectus in sodales tristique varius libero....",
    href: "#",
    linkText: "Read more >>",
  },
  {
    src: blog_image,
    title: "Creative project management and practices for 2021",
    subtitle:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Eu nisi amet in pellentesque. Imperdiet ac amet arcu lectus in sodales tristique varius libero....",
    href: "#",
    linkText: "Read more >>",
  },
  {
    src: blog_image,
    title: "Creative project management and practices for 2021",
    subtitle:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Eu nisi amet in pellentesque. Imperdiet ac amet arcu lectus in sodales tristique varius libero....",
    href: "#",
    linkText: "Read more >>",
  },
  {
    src: blog_image,
    title: "Creative project management and practices for 2021",
    subtitle:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Eu nisi amet in pellentesque. Imperdiet ac amet arcu lectus in sodales tristique varius libero....",
    href: "#",
    linkText: "Read more >>",
  },
  {
    src: blog_image,
    title: "Creative project management and practices for 2021",
    subtitle:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Eu nisi amet in pellentesque. Imperdiet ac amet arcu lectus in sodales tristique varius libero....",
    href: "#",
    linkText: "Read more >>",
  },
  {
    src: blog_image,
    title: "Creative project management and practices for 2021",
    subtitle:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Eu nisi amet in pellentesque. Imperdiet ac amet arcu lectus in sodales tristique varius libero....",
    href: "#",
    linkText: "Read more >>",
  },
  {
    src: blog_image,
    title: "Creative project management and practices for 2021",
    subtitle:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Eu nisi amet in pellentesque. Imperdiet ac amet arcu lectus in sodales tristique varius libero....",
    href: "#",
    linkText: "Read more >>",
  },
  {
    src: blog_image,
    title: "Creative project management and practices for 2021",
    subtitle:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Eu nisi amet in pellentesque. Imperdiet ac amet arcu lectus in sodales tristique varius libero....",
    href: "#",
    linkText: "Read more >>",
  },
  {
    src: blog_image,
    title: "Creative project management and practices for 2021",
    subtitle:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Eu nisi amet in pellentesque. Imperdiet ac amet arcu lectus in sodales tristique varius libero....",
    href: "#",
    linkText: "Read more >>",
  },
  {
    src: blog_image,
    title: "Creative project management and practices for 2021",
    subtitle:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Eu nisi amet in pellentesque. Imperdiet ac amet arcu lectus in sodales tristique varius libero....",
    href: "#",
    linkText: "Read more >>",
  },
  {
    src: blog_image,
    title: "Creative project management and practices for 2021",
    subtitle:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Eu nisi amet in pellentesque. Imperdiet ac amet arcu lectus in sodales tristique varius libero....",
    href: "#",
    linkText: "Read more >>",
  },
  {
    src: blog_image,
    title: "Creative project management and practices for 2021",
    subtitle:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Eu nisi amet in pellentesque. Imperdiet ac amet arcu lectus in sodales tristique varius libero....",
    href: "#",
    linkText: "Read more >>",
  },
  {
    src: blog_image,
    title: "Creative project management and practices for 2021",
    subtitle:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Eu nisi amet in pellentesque. Imperdiet ac amet arcu lectus in sodales tristique varius libero....",
    href: "#",
    linkText: "Read more >>",
  },
  {
    src: blog_image,
    title: "Creative project management and practices for 2021",
    subtitle:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Eu nisi amet in pellentesque. Imperdiet ac amet arcu lectus in sodales tristique varius libero....",
    href: "#",
    linkText: "Read more >>",
  },
  {
    src: blog_image,
    title: "Creative project management and practices for 2021",
    subtitle:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Eu nisi amet in pellentesque. Imperdiet ac amet arcu lectus in sodales tristique varius libero....",
    href: "#",
    linkText: "Read more >>",
  },
  {
    src: blog_image,
    title: "Creative project management and practices for 2021",
    subtitle:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Eu nisi amet in pellentesque. Imperdiet ac amet arcu lectus in sodales tristique varius libero....",
    href: "#",
    linkText: "Read more >>",
  },
  {
    src: blog_image,
    title: "Creative project management and practices for 2021",
    subtitle:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Eu nisi amet in pellentesque. Imperdiet ac amet arcu lectus in sodales tristique varius libero....",
    href: "#",
    linkText: "Read more >>",
  },
  {
    src: blog_image,
    title: "Creative project management and practices for 2021",
    subtitle:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Eu nisi amet in pellentesque. Imperdiet ac amet arcu lectus in sodales tristique varius libero....",
    href: "#",
    linkText: "Read more >>",
  },
  {
    src: blog_image,
    title: "Creative project management and practices for 2021",
    subtitle:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Eu nisi amet in pellentesque. Imperdiet ac amet arcu lectus in sodales tristique varius libero....",
    href: "#",
    linkText: "Read more >>",
  },
];
